var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DCP-Manage-Rides",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-Rides",
    transform: "translate(-253.000000, -787.000000)",
    fill: "#4CAF50",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_circle_checkmark-2",
    transform: "translate(253.000000, 787.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,13.6666667 C3.31810167,13.6666667 0.333333333,10.6818983 0.333333333,7 C0.333333333,3.31810167 3.31810167,0.333333333 7,0.333333333 C10.6818983,0.333333333 13.6666667,3.31810167 13.6666667,7 C13.6666667,10.6818983 10.6818983,13.6666667 7,13.6666667 Z M5.33333333,8.39052429 L3.47140452,6.52859548 L2.52859548,7.47140452 L5.33333333,10.2761424 L10.8047379,4.80473785 L9.86192881,3.86192881 L5.33333333,8.39052429 Z",
    id: "shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarted);
export default __webpack_public_path__ + "static/media/started.64543504a688e962216947f82764fc2e.svg";
export { ForwardRef as ReactComponent };